import { GoClock } from "react-icons/go";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { useLocation } from "react-router-dom";
import SellerDetails from "../../Shared/ListingDetails/Details";
import MyBusinessListingDetails from "../MyBusinessListing/MyBusinessListingDetails";
import MessageDetails from "../MyMessages/MessageDetails";
import {
  default as ReviewsDetails,
  default as WatchListDetails,
} from "./ReviewsDetails";

const Details = () => {
  const location = useLocation();
  const path = location.pathname;

  if (
    path === "/user/bidding-on" ||
    path === "/user/won-and-bought" ||
    path === "/user/sold-items"
  ) {
    return <SellerDetails location="London, UK" seller="Ben88" />;
  } else if (path === "/user/watch-list") {
    return <WatchListDetails />;
  }

  switch (path) {
    case "/user/bidding-on":
    case "/user/won-and-bought":
    case "user/sold-items":
      return <SellerDetails location="London, UK" seller="Ben88" />;
    case "/user/watch-list":
      return <WatchListDetails />;
    case "/user/message":
    case "/user/chat":
    case "/user/listing-offers":
      return <MessageDetails location="Pretoria" seller="Ben88" />;
    case "/user/my-business":
      return <MyBusinessListingDetails />;

    case "/user/reviews-receieved":
    case "/user/reviews-given":
    case "/user/reviews-pending":
      return <ReviewsDetails />;
    default:
      return (
        <div className="flex w-4/5 justify-between gap-10">
          <div className="flex items-center gap-3">
            <HiOutlineLocationMarker className=" h-5 w-5 text-redBorder" />
            <span className="font-pop text-base font-medium text-darkGreen">
              Pretoria
            </span>
          </div>
          <p className="font-pop text-base font-medium text-darkGreen">
            Views:- 67
          </p>

          <div className="flex items-center gap-3">
            <GoClock className=" h-5 w-5 text-redBorder" />
            <span className="font-pop text-base font-medium text-darkGreen">
              2 days ago
            </span>
          </div>
        </div>
      );
  }
};

export default Details;
